export enum UploadStatus {
    Requested = 'Requested',
    Uploading = 'Uploading',
    Scanning = 'Scanning',
    Completed = 'Completed',
    Failed = 'Failed',
    Expired = 'Expired',
}

export enum FileScanStatus {
    NotStarted = 'Not Started',
    Pending = 'Pending',
    NoMalware = 'No Malware',
    Malware = 'Malware',
    Unknown = 'Unknown',
    DownloadFailure = 'DOWNLOAD_FAILURE',
    FileNotFound = 'FILE_NOT_FOUND',
}

export enum FileConversionStatus {
    NA = 'N/A',
    Pending = 'Pending',
    Completed = 'Completed',
    Failed = 'Failed',
}

export enum SftJobStatus {
    NOT_STARTED = 'NOT_STARTED',
    PENDING = 'PENDING',
    COMPLETED = 'COMPLETED',
    FAILED = 'FAILED',
    MALWARE = 'MALWARE',
}
